module.exports = __webpack_public_path__ + "static/media/mobileWeb.d3bae0a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/TrulyMadly/mobileWeb.jpg
// module id = 370
// module chunks = 0